import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { MenuUnfoldOutlined, MenuFoldOutlined, CloudUploadOutlined, LineChartOutlined, PaperClipOutlined, UserSwitchOutlined, HistoryOutlined, SettingOutlined, DatabaseOutlined } from '@ant-design/icons';



import ButtonSimple from '@/components/ButtonSimple';


import { clearAuth } from '@/services/service';
import { usePagePreloader } from '@/hooks/useLazyLoad';

import { USER_SVG, LOGOUT_SVG } from '@/utils/image';
import { IconDashboardMd } from '@/utils/icons';
import useUserStore from '@/store/user';
import { logHelper } from '@/utils';

const { Header, Sider, Content } = Layout;

const MainLayout: React.FC = () => {

  const TAG: string = 'MainLayout: ';
  const navigate = useNavigate();
  const location = useLocation();
  const { preloadPage } = usePagePreloader();
  const { user } = useUserStore();
  const [collapsed, setCollapsed] = useState(false);

  const menuItemsAdmin = [
    {
      key: '/',
      icon: <IconDashboardMd />,
      label: <span className="text-[12px] font-semibold ">Dashboard</span>,
    },
    {
      key: '/data-upload',
      icon: <CloudUploadOutlined />,
      label: <span className="text-[12px] font-semibold ">Data Upload</span>,
    },
    {
      key: '/view-charts',
      icon: <LineChartOutlined />,
      label: <span className="text-[12px] font-semibold ">View Charts</span>,
    },
    // {
    //   key: '/complete-dashboard',
    //   icon: <HomeOutlined />,
    //   label: <span className="text-[12px] font-semibold ">Complete Dashboard</span>,
    // },
    {
      key: '/template-management',
      icon: <PaperClipOutlined />,
      label: <span className="text-[12px] font-semibold ">Template Management</span>,
    },
    {
      key: '/data-house',
      icon: <DatabaseOutlined />,
      label: <span className="text-[12px] font-semibold ">Data House</span>,
    },
    {
      key: '/user-management',
      icon: <UserSwitchOutlined />,
      label: <span className="text-[12px] font-semibold ">User Management</span>,
    },
    // {
    //   key: '/role-management',
    //   icon: <IconUserCheck />,
    //   label: <span className="text-[12px] font-semibold ">Role Management</span>,
    // },
    // {
    //   key: '/permission-management',
    //   icon: <IconIoAccessibility />,
    //   label: <span className="text-[12px] font-semibold ">Permission Management</span>,
    // },
    {
      key: '/activity-logs',
      icon: <HistoryOutlined />,
      label: <span className="text-[12px] font-semibold ">Activity Logs</span>,
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: <span className="text-[12px] font-semibold ">Settings</span>,
    },
  ];

  const menuItemsUser = [
    {
      key: '/',
      icon: <IconDashboardMd />,
      label: <span className="text-[12px] font-semibold ">Dashboard</span>,
    },
    {
      key: '/data-upload',
      icon: <CloudUploadOutlined />,
      label: <span className="text-[12px] font-semibold ">Data Upload</span>,
    },
    {
      key: '/view-charts',
      icon: <LineChartOutlined />,
      label: <span className="text-[12px] font-semibold ">View Charts</span>,
    },
    // {
    //   key: '/complete-dashboard',
    //   icon: <HomeOutlined />,
    //   label: <span className="text-[12px] font-semibold ">Complete Dashboard</span>,
    // },
    {
      key: '/activity-logs',
      icon: <HistoryOutlined />,
      label: <span className="text-[12px] font-semibold ">Activity Logs</span>,
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: <span className="text-[12px] font-semibold ">Settings</span>,
    },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    // Preload the target page before navigation
    const pageName = key === '/' ? 'home' : key.slice(1); // Remove leading slash
    preloadPage(pageName);
    navigate(key);
  };


  const handleLogout = () => {
    clearAuth();
  };

  // logHelper(TAG, ' user ', user);

  return (
    <Layout className="min-h-screen !font-montserrat">

      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="md"
        collapsedWidth="0"
        width={250}
        onBreakpoint={(broken) => {
          if (broken) {
            setCollapsed(true);
          }
        }}
        className="bg-white border-r border-gray-200"
      >
        <div className="sticky top-0 left-0 right-0 z-50 bg-white ">
          <div className=" flex items-center justify-start p-4 border-b border-gray-200 bg-white ">
            <div className="w-[40px] h-[40px] overflow-hidden shrink-0 flex justify-center items-center" >
              <img
                src="https://avatars.githubusercontent.com/u/124599?v=4"
                alt="logo"
                className="w-full h-full rounded-full"
                loading="lazy"
              />
            </div>
            <div className="ml-2 leading-[1.3] text-left">
              <span className="text-[13px] text-gray-900 truncate font-bold uppercase">{user?.full_name}</span>
              <br />
              <span className="text-[14px] text-gray-500 truncate font-normal uppercase">{user?.role?.name}</span>
            </div>
          </div>

          <Menu
            theme="light"
            mode="inline"
            selectedKeys={[location.pathname]}
            items={user?.role?.key === 'admin' ? menuItemsAdmin : menuItemsUser}
            onClick={handleMenuClick}
            className=" text-gray-600 hover:text-gray-900 hover:bg-gray-50 p-2 bg-white "
          />
        </div>
      </Sider>

      <Layout className=" !bg-[#F0F8FF]  ">

        <Header className=" sticky top-0 left-0 right-0 z-50 flex items-center  justify-center !h-[80px] bg-white border-b border-gray-200 px-6  ">

          <div className=" absolute left-[1rem] flex !h-[80px] items-center  ">

            <ButtonSimple
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              className="text-base w-16 h-16 block "
            />

            <div className="h-full flex items-center">
              <div className="m-0 h-fit w-fit leading-[1]">
                <span className="font-bold text-[24px]">M&E Dashboard</span>
                <br />
                <span className="text-sm text-gray-600">Monitoring & Evaluation Tool</span>
              </div>
            </div>
          </div>


          <div className=" absolute right-[1rem] hidden md:flex ">
            <div className="flex items-center">
              <div className="">
                <img src={USER_SVG} alt="user" className="w-5 h-5" loading="lazy" />
              </div>
              <div className="ml-2 leading-[1]"><span className="text-sm font-bold">{user?.full_name}</span> <br /> <span className="text-xs text-gray-500">{user?.role?.name}</span></div>
            </div>

            <div className="flex items-center ml-4 py-3 h-fit shrink-0 border-[1px] border-gray-200 px-3 rounded-md cursor-pointer hover:bg-gray-100 transition-all duration-300"
              onClick={handleLogout}
            >
              <img src={LOGOUT_SVG} alt="logout" className="w-5 h-5" loading="lazy" />
              <span className="text-sm font-bold ml-2">Logout</span>
            </div>
          </div>

          <div className=" absolute right-[1rem] md:hidden ">
            <div
              className=" flex items-center ml-4 py-3 h-fit shrink-0 border-[1px] border-gray-200 px-3 rounded-md cursor-pointer hover:bg-gray-100 transition-all duration-300 "
              onClick={handleLogout}
            >
              <img src={LOGOUT_SVG} alt="logout" className="w-5 h-5" loading="lazy" />
              <span className="text-sm font-bold ml-2">Logout</span>
            </div>
          </div>

        </Header>

        <Content className="m-0 p-3 md:p-6 min-h-[280px] overflow-hidden bg-[#f9fafb] flex flex-col ">
          <Outlet />
        </Content>

      </Layout>
    </Layout>
  );
};

export default MainLayout; 